import { NoDecimalCurrencyFormatterPipe } from './pipes/no-decimal-currency.pipe';
import { DateWithLocalePipe } from './pipes/date-with-locale.pipe';
import { RoundDownFormatterPipe } from './pipes/round-down-formatter.pipe';
import { CurrencyFormatterPipe } from './pipes/currency-formatter.pipe';
import { CreditFormatterPipe } from './pipes/credit-formatter.pipe';
import { ReversePipe } from './pipes/reverse.pipe';
import { UnescapePipe } from './pipes/unescape.pipe';
import { CompHostDirective } from './directives/compHost.directive';
import { DndDirective } from './directives/drag-n-drop.directive';
import { AddComponent } from './add/add.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WrapperCardComponent } from './wrapper-card/wrapper-card.component';
import { ButtonComponent } from './button/button.component';
import { ErrorComponent } from './error/error.component';
import { LinkButtonComponent } from './link-button/link-button.component';
import { ModalComponent } from './modal/modal.component';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { VideoComponent } from './video/video/video.component';
import { AppointmentTrialComponent } from './appointment-trial/appointment-trial.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { BindHTMLDirective } from './directives/bindHTML.directive';
import { FormatCurrencyDirective } from './directives/formatCurrency.directive';
import { DialogCoreComponent } from './dialogs/dialog-core/dialog-core.component';
import { InfoDialogComponent } from './dialogs/info-dialog/info-dialog.component';
import { HearAboutComponent } from './hear-about/hear-about.component';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { SpinnerComponent } from './spinner/spinner.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { PasswordValidatorDirective } from './directives/password-validator.directive';
import { PhoneValidatorDirective } from './directives/phone-validator.directive';
import { CourseSelectionComponent } from './course-selection/course-selection.component';
import { CustomDateAdapter } from '../../services/CustomDateAdapter';
import { MatTooltip } from '@angular/material/tooltip';
export const MY_FORMATS = {
	parse: {
		dateInput: 'DD-MM-YYYY',
	},
	display: {
		dateInput: 'DD-MM-YY',
		monthYearLabel: 'MMM YYYY'
	},
};

@NgModule({
	declarations: [
		WrapperCardComponent,
		AppointmentTrialComponent,
		ButtonComponent,
		ErrorComponent,
		LinkButtonComponent,
		ModalComponent,
		VideoComponent,
		BindHTMLDirective,
		FormatCurrencyDirective,
		DndDirective,
		AddComponent,
		CompHostDirective,
		DialogCoreComponent,
		InfoDialogComponent,
		HearAboutComponent,
		ReversePipe,
		SpinnerComponent,
		SvgIconComponent,
		PasswordValidatorDirective,
		PhoneValidatorDirective,
		CourseSelectionComponent,
		UnescapePipe,
		CurrencyFormatterPipe,
		CreditFormatterPipe,
		RoundDownFormatterPipe,
		NoDecimalCurrencyFormatterPipe,
		DateWithLocalePipe
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		LocalizeRouterModule,
		ReactiveFormsModule,
		RouterModule,
		TranslateModule,
		NgSelectModule,
		MatTooltip

	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		LocalizeRouterModule,
		ReactiveFormsModule,
		RouterModule,
		TranslateModule,
		NgSelectModule,
		//TippyModule,
		BindHTMLDirective,
		PasswordValidatorDirective,
		PhoneValidatorDirective,
		FormatCurrencyDirective,
		WrapperCardComponent,
		AppointmentTrialComponent,
		ButtonComponent,
		ErrorComponent,
		LinkButtonComponent,
		ModalComponent,
		VideoComponent,
		AddComponent,
		DndDirective,
		CompHostDirective,
		InfoDialogComponent,
		HearAboutComponent,
		ReversePipe,
		SpinnerComponent,
		SvgIconComponent,
		CourseSelectionComponent,
		UnescapePipe,
		CurrencyFormatterPipe,
		CreditFormatterPipe,
		RoundDownFormatterPipe,
		NoDecimalCurrencyFormatterPipe,
		DateWithLocalePipe
	],
	providers: [
		{
			provide: DateAdapter,
			useClass: CustomDateAdapter,
		},
		{
			provide: MAT_DATE_FORMATS,
			useValue: MY_FORMATS
		}
	]
})
export class SharedModule { }
